/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from './StyleConstant';
import { caseInsensitiveComparator } from '../../../Display/NDC/utility/tableHeads';

export const labelerTableHead = [
  {
    headerName: 'Labeler Code',
    field: 'labelerCode',
    editable: false,
    sortable: true,
    sort: 'asc',
    sortingOrder: ['asc', 'desc'],
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    resizable: false,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Labeler Name',
    field: 'labelerName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    comparator: caseInsensitiveComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const NDCTableHead = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'ndc',
    sortingOrder: ['asc', 'desc'],
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'drugName',
    cellClass: 'frr-ellipsis-text',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
